import {ON_DENOMINATION_LIST} from './../constants/ActionTypes';

const INIT_STATE = {
  denominations : []
}

export default (state= INIT_STATE,action) =>{
  switch(action.type){
      case ON_DENOMINATION_LIST: {
      return {
        ...state,
        denominations: action.payload
      };
    }
    default: {
      return state;
  }
  }
}